import { isCotaOrExtra, parseTournamentEvents } from "./data";
import { parseAdditionalData } from "./parseAdditionalData";
import { parseMacroGruppi } from "./parseMacroGruppi";
import { parseOutrightsData } from "./parseOutrightsData";
import { filterByCustomizedState, getConfiguration, getDBTimestampFromDate, getLocaleTimestamp, groupEventsByDate } from "./utils";

export function parseTournamentData(data, tournamentData, tournamentId, aggId, isLive, compattaParametriche) {
    const conf = getConfiguration();
    // Filter expired events
    let events = tournamentData?.avs;
    if (!isLive) {
        events = events?.filter(avv => {
            const matchTimestamp = conf.dbutc ? getLocaleTimestamp(avv.ts) : avv.ts;
            const currentTimestamp = getDBTimestampFromDate(new Date());
            return matchTimestamp.localeCompare(currentTimestamp) > 0;
        });
    }
    events = filterByCustomizedState(events)
    const tournament = {
        // Recupera i dati del torneo
        ...data.tournamentByUniqueId[tournamentId],
        // Aggiungi gli eventi al torneo
        events
    };
    let aggs = tournamentData.ags;
    if (!window.isCotaExtraEnabled) {
        aggs = aggs.filter(aggId => !isCotaOrExtra(isLive, tournament.sportRef, aggId));
    }
    tournament.events = parseTournamentEvents(data, tournament, aggs, aggId, isLive, compattaParametriche);

    // Aggiungi i macrogruppi, se esistono
    tournament.macrogruppi = tournament.events.length > 0 ? parseMacroGruppi(tournament.events[0].gruppoById, tournament.sportRef, false) : [];
    //Aggiungo classifica
    tournament.classifica = conf.ps.clt.length > 0? tournamentData.sid : null;
    tournament.outrights = tournamentData.ors ? parseOutrightsData(tournamentData.ors, tournament.sportRef,tournament.descrizione,data.sportById[tournament.sportRef].descrizione) : [];
	tournament.betbuilder = tournamentData.bb;
    [tournament.dates, tournament.matchesByDate] = groupEventsByDate(tournament.events);
    tournament.additionalData = parseAdditionalData(tournamentData.add);

    return tournament;
}
